import React from 'react';
import PropTypes from 'prop-types';
import Link from '@cotyorg/ccx-atoms/Link';

const Extlink = ({ children, link }) => <Link link={link} target="_blank">{children}</Link>;

Extlink.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string.isRequired,
};

export default Extlink;
